var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isModalOpen
    ? _c("div", { staticClass: "comment-modal" }, [
        _c("div", {
          staticClass: "comment-modal__body",
          domProps: { innerHTML: _vm._s(_vm.modalMessage) }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "comment-modal__button",
          on: { click: _vm.hideModal }
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }